module.exports = __webpack_public_path__ + "static/micro-usb-80efdcf24bcf761e0d71443a5c03d2c3.svg";